import { Box } from "@mui/material"
import React, { useState } from "react"

import { Page, pdfjs, Document } from "react-pdf"
import "react-pdf/dist/Page/TextLayer.css"
import "react-pdf/dist/esm/Page/AnnotationLayer.css"
import ExfluencyLoader from "src/components/ExfluencyLoader"

pdfjs.GlobalWorkerOptions.workerSrc = "https://cdn.jsdelivr.net/npm/pdfjs-dist@4.8.69/build/pdf.worker.min.mjs"

export type LegalDocumentI = "GENERAL_TERMS" | "PRIVACY_POLICY_REQUESTERS"

interface Props {
  legalDocument: LegalDocumentI
}

const LegalDocument = ({ legalDocument }: Props) => {
  const [numPages, setNumPages] = useState<number>()

  const onDocumentLoadSuccess = ({ numPages }: { numPages: number }) => {
    setNumPages(numPages)
  }

  return (
    <>
      <Box>
        <Document
          file={`/api/wfl/documents/${legalDocument}`}
          onLoadSuccess={onDocumentLoadSuccess}
          loading={
            <Box sx={{ width: 892 }}>
              <ExfluencyLoader noBackgroundColor />
            </Box>
          }
        >
          {Array.from(new Array(numPages), (el, index) => (
            <Page key={`page_${index + 1}`} pageNumber={index + 1} scale={1.5}/>
          ))}
        </Document>
      </Box>
    </>
  )
}

export default LegalDocument
